<template lang="pug">
q-dialog(ref="activeRef", v-model="active", persistent, transition-show="slide-left", transition-hide="slide-right")
  q-card.floor-map-dialog-card
    q-card-section
      .floor-plan-dot-detail
        .spinner-container(v-if="loading")
          q-spinner(color="primary", size="3em")
        .floor-plan-dot-detail-container(v-else)
          div(v-if="dot.type === 'equipments'")
            .floor-plan-dot-detail-header
              .floor-plan-dot-detail-header-left
                inline-svg.form-card-title-icon(:src="require(`../../../../assets/icons/form/header/file_header.svg`)")
                p {{ `${type} №${detailInfo.id}` }}
              q-btn(dense, flat, icon="close", @click="hideDetail")

            q-separator

            .floor-plan-dot-detail-tech-map
              .floor-plan-dot-detail-specification
                .floor-plan-dot-detail-specification-item(
                  v-for="item in detailInfo.specification",
                  :key="item.key || item.name"
                )
                  .floor-plan-dot-detail-specification-item-left {{ item.key || item.name }}
                  .floor-plan-dot-detail-specification-item-right {{ item.value || "–" }}

              .floor-plan-dot-detail-tabs
                q-card
                  q-tabs.text-grey(
                    v-model="componentsTab",
                    dense,
                    active-color="primary",
                    indicator-color="primary",
                    align="justify",
                    narrow-indicator
                  )
                    q-tab(name="components", label="Компоненты")
                    q-tab(name="replaced_components", label="Замена компонентов")
                    q-tab(v-if="detailInfo.issues.length > 0", name="issues", label="Заявки")

                  q-separator

                  q-tab-panels(v-model="componentsTab", animated)
                    q-tab-panel(name="components")
                      detail-tabs(:parentData="{ tabs: detailInfo.components }")
                    q-tab-panel(name="replaced_components")
                      detail-tabs(:parentData="{ tabs: detailInfo.replaced_components }")
                    q-tab-panel(name="issues")
                      detail-tabs-issues(:parentData="{ tabs: detailInfo.issues }")

          div(v-if="dot.type === 'meters'")
            .floor-plan-dot-detail-header
              .floor-plan-dot-detail-header-left
                inline-svg.form-card-title-icon(:src="require(`../../../../assets/icons/form/header/file_header.svg`)")
                p {{ `${type} №${detailInfo.id}` }}
              q-btn(dense, flat, icon="close", @click="hideDetail")

            q-separator

            .floor-plan-dot-detail-tech-map
              .floor-plan-dot-detail-specification
                .floor-plan-dot-detail-specification-item(v-for="item in detailInfo.recording", :key="item.date")
                  .floor-plan-dot-detail-specification-item-left {{ item.date }}
                  .floor-plan-dot-detail-specification-item-right {{ item.record || "–" }}
</template>

<script setup>
// Возможно надо сносить. Данный компонент может быть отображен только если в компоненте floor_point переменная active будет true
// Функция назначающая переменную active true была закомментирована 3 года назад и соответственно этот компонент не может быть отображен
import { ref, onBeforeMount } from "vue";
import detailTabs from "./detail_tabs.vue";
import detailTabsIssues from "./detail_issue-tabs.vue";
const props = defineProps({
  parentData: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["hide"]);

const dot = ref(props.parentData.dot);
const active = ref(props.parentData.active);

const detailInfo = ref({});
const loading = ref(false);
const type = ref("");
const componentsTab = ref("components");

const getDetailInfo = async (typeArg = dot.value.type) => {
  loading.value = true;

  switch (dot.value.type) {
    case "equipments":
      type.value = "Оборудование";
      break;
    case "meters":
      type.value = "Счетчик";
      break;
    default:
      type.value = "Оборудование";
      break;
  }

  if (typeArg === "equipments") {
    const res = await $backend.index(`api/v3/ppr/${dot.value.type}/${dot.value.value}`, {});
    const data = res.data.common.data;

    detailInfo.value = {
      id: data.id,
      specification: data.technological_map.specification,
      components: data.technological_map.components,
      replaced_components: data.technological_map.replaced_components,
      issues: data.issues,
    };

    loading.value = false;
    return;
  }

  if (typeArg === "sensors") return;

  if (typeArg === "meters") {
    const res = await $backend.index(`api/v3/measuring/${dot.value.type}/${dot.value.value}`);
    const data = res.data;

    detailInfo.value.id = data.id;

    const resp = await $backend.index(
      `api/v3/measuring/meter_readings/collection?measuring_meter_id=${dot.value.value}`,
    );

    const recordings = [];
    resp.data.options.forEach(item => {
      recordings.unshift({
        record: item.title,
        date: item.reading_at,
      });
    });

    detailInfo.value.recording = recordings;
    loading.value = false;
  }
};

const hideDetail = () => {
  emit("hide");
};

onBeforeMount(() => {
  getDetailInfo();
});
</script>

<style lang="scss">
@import "../../../../assets/styles/floor-plan/main";
</style>
